import * as THREE from "../src/insole-web-common/vendor/three/build/three.module.js";
const tmpVec3 = new THREE.Vector3();
const tmpMat3 = new THREE.Matrix3();
const tmpMat4 = new THREE.Matrix4();
const tmpRayBoxIntersectionInvDir = new THREE.Vector3();
// Returns the distance from the ray origin to the hit point, or null if no hit
export function IntersectRayAABB(ray, aabb) {
    // https://tavianator.com/2022/ray_box_boundary.html
    let tMin = -Infinity;
    let tMax = Infinity;
    const min = (x, y) => (x < y ? x : y);
    const max = (x, y) => (x > y ? x : y);
    tmpRayBoxIntersectionInvDir.setScalar(1).divide(ray.direction);
    for (let i = 0; i < 3; ++i) {
        const rayOriginComponent = ray.origin.getComponent(i);
        const invDirComponent = tmpRayBoxIntersectionInvDir.getComponent(i);
        const t1 = (aabb.min.getComponent(i) - rayOriginComponent) * invDirComponent;
        const t2 = (aabb.max.getComponent(i) - rayOriginComponent) * invDirComponent;
        tMin = min(max(t1, tMin), max(t2, tMin));
        tMax = max(min(t1, tMax), min(t2, tMax));
    }
    if (tMin <= tMax && tMin >= 0) {
        return tMin;
    }
    else {
        return null;
    }
}
export function TransformRay(ray, matrix, target) {
    target.copy(ray);
    target.origin.applyMatrix4(matrix);
    target.direction.applyMatrix3(tmpMat3.setFromMatrix4(matrix)).normalize();
    return target;
}
export function WorldRayToLocal(ray, obj, target) {
    const matrixWorldInverse = tmpMat4.copy(obj.matrixWorld).invert();
    return TransformRay(ray, matrixWorldInverse, target);
}
export function IntersectRaySphere(sphereCenter, sphereRadius, ray) {
    const dir = tmpVec3.subVectors(ray.origin, sphereCenter);
    const x = ray.direction.dot(dir);
    const c = dir.lengthSq() - sphereRadius * sphereRadius;
    const d = x * x - c;
    if (d < 0) {
        return null;
    }
    const sqrtD = Math.sqrt(d);
    // const t1 = -x + sqrtD;
    const t2 = -x - sqrtD;
    return t2;
}
export function GetClosestPointToLine(linePoint, lineDirection, point, target) {
    return target
        .copy(lineDirection)
        .multiplyScalar(tmpVec3.subVectors(point, linePoint).dot(lineDirection))
        .add(linePoint);
}
//# sourceMappingURL=geometry.js.map